import { useLang } from "../../hooks/LangHooks";
import { FaqCategory } from "../../types/Faq";
import { useBjelinTranslations } from "../../hooks/TranslationHooks";
import { Link } from "react-router-dom";
import Icon from "../Icon";
import { faqUrl, useFaqData } from "../../hooks/FaqHooks";
import { useUser } from "../../functional-components/UserContext";

export const FaqCategoryOverview = ({
  category
}: {
  category: FaqCategory;
}) => {
  const { admin } = useUser();
  const t = useBjelinTranslations();
  const lang = useLang();
  const faqData = useFaqData(lang);
  const articles = faqData.articles.filter(
    article => article.categories.indexOf(category._id) >= 0
  );

  return (
    <div className="category-item">
      <h2>
        <Link to={faqUrl({ category })}>{category.name}</Link>
        {admin && (
          <span className={"text-small text-muted"}> ({articles.length})</span>
        )}
      </h2>
      <ul className="faq-samples">
        {articles.slice(0, 5).map(article => (
          <li key={article.id}>
            {admin && article.promoted_article && (
              <span
                className={"text-danger"}
                style={{ cursor: "help" }}
                title={"Promoted"}
              >
                *
              </span>
            )}
            <Link to={faqUrl({ category, article })} className="faq-item-link">
              {article.title}
            </Link>
          </li>
        ))}
        {articles.length > 5 && (
          <li className="more">
            <Link to={faqUrl({ category })}>
              {t("more")}
              <Icon name="chevron-right" type="fal" className="more-icon" />
            </Link>
          </li>
        )}
      </ul>
    </div>
  );
};
